import { render, staticRenderFns } from "./baseTable.vue?vue&type=template&id=b92dceda&scoped=true"
import script from "./baseTable.vue?vue&type=script&lang=js"
export * from "./baseTable.vue?vue&type=script&lang=js"
import style0 from "./baseTable.vue?vue&type=style&index=0&id=b92dceda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92dceda",
  null
  
)

export default component.exports